import { EntityEnum } from '@c2b/muven-commons'

export default {
    methods: {
        getEntityUrl(id:string, entity:string):string {
            switch (entity) {
                case EntityEnum.Order:
                    return `/pedidos/${id}`
                
                case EntityEnum.Product:
                    return `/produtos/${id}`

                case EntityEnum.Category:
                    return `/categorias/${id}`

                case EntityEnum.Brand:
                    return `/marcas/${id}`

                case EntityEnum.Payment:
                    return `/formas_pagamento/${id}`

                case EntityEnum.DeliveryCompany:
                    return `/transportadoras/${id}`

                default:
                    return ""
            }

        },
    },
}
